import $ from 'jquery';

class TcrLoginClass
{
    constructor()
    {
        this.url = this.url;

        this.clientUpdated = this.clientUpdated.bind(this);
        this.setUrl = this.setUrl.bind(this);
        this.checkStatus = this.checkStatus.bind(this);
        this.mail = this.mail.bind(this);
        this.name = this.name.bind(this);
        this.logout = this.logout.bind(this);
        this.login = this.login.bind(this);
        this.reset = this.reset.bind(this);
        this.signup = this.signup.bind(this);
    }

    setUrl(url)
    {
        this.url = url;
    }

    checkStatus(cb)
    {
        $.ajax({
            method: 'post',
            url: this.url,
            data: {
                'tcr_request': "login.check"
            },
            dataType: 'json',
            xhrFields: {
                withCredentials: true
            }
        }).done((data) =>
        {
            if (data.status == 'ok' && data.credentials.status == true)
            {
                this.user_mail = data.credentials.user.mail;
                this.user_name = data.credentials.user.name;
                cb(data.credentials);
            }
            else
            {
                delete this.user_mail;
                delete this.user_name;
                cb({status: false});
            }
        }).fail(() =>
        {
            cb({status: false});
        });
    }

    mail()
    {
        return this.user_mail || '';
    }

    name()
    {
        return this.user_name || '';
    }

    logout()
    {
        return new Promise((resolve) => {
            $.ajax({
                method: 'post',
                url: this.url,
                data: {
                    'tcr_request': "logout"
                },
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                }
            }).done(() =>
            {
                if (typeof TcrClient !== 'undefined' && typeof TcrClient.onLogout === 'function')
                {
                    TcrClient.onLogout();
                    resolve(true);
                }
                resolve(false);
            });
        });
    }

    /**
     * 
     * @param {*} email 
     * @param {*} password 
     * @param {*} next 
     */
    login(email, password, otp, next)
    {
        $.ajax(
        {
            method: 'post',
            url: this.url,
            data: {
                'tcr_request': 'tcr_login',
                'tcr_data': JSON.stringify({
                    'email': email,
                    'password': password,
                    'otp': otp
                })
            },
            dataType: 'json',
            xhrFields: {
                withCredentials: true
            }
        }).done(function(data)
        {
            if (data.status == 'ok')
            {
                console.log('Smart Login: login successful');
                if (typeof TcrClient !== 'undefined' && typeof TcrClient.onLogin === 'function')
                {
                    TcrClient.onLogin();
                }
                next('ok');
            }
            else
            {
                console.log('Smart Login: ' + data.message);
                next(data.message, data);
            }
        }).fail(function()
        {
            console.log('Smart Login: no connection');
            next('no_connection');
        });
    }

    reset(email, otp, newpassword, next)
    {
        $.ajax(
        {
            method: 'post',
            url: this.url,
            data: {
                'tcr_request': 'tcr_login_reset_password',
                'tcr_data': JSON.stringify({
                    'email': email,
                    'otp': otp,
                    'password': newpassword
                })
            },
            dataType: 'json',
            xhrFields: {
                withCredentials: true
            }
        }).done(function(data)
        {
            if (data.status == 'ok')
            {
                console.log('Smart Login: reset successful');
                next('ok');
            }
            else
            {
                console.log('Smart Login: ' + data.message);
                next(data.message);
            }
        }).fail(function()
        {
            console.log('Smart Login: no connection');
            next('no_connection');
        });
    }

    signup(email, otp, newpassword, username, next)
    {
        $.ajax(
        {
            method: 'post',
            url: this.url,
            data: {
                'tcr_request': 'tcr_login_signup',
                'tcr_data': JSON.stringify({
                    'email': email,
                    'otp': otp,
                    'password': newpassword,
                    'name': username
                })
            },
            dataType: 'json',
            xhrFields: {
                withCredentials: true
            }
        }).done(function(data)
        {
            if (data.status == 'ok')
            {
                console.log('Smart Login: signup successful');
                next('ok');
            }
            else
            {
                console.log('Smart Login: ' + data.message);
                next(data.message);
            }
        }).fail(function()
        {
            console.log('Smart Login: no connection');
            next('no_connection');
        });
    }

    do_sso()
    {
        if (window.trcloud.sso && window.trcloud.sso.host)
        {
            let currentUrl = window.location.href.split('?')[0];
            let host = window.trcloud.sso.host;
            let url = `https://${host}/sign-in?svc=${currentUrl}`;
            window.open(url, '_self');
        }
    }

    getUserOptions()
    {
        return [].concat(this.user_options);
    }

    getUserInitials(email)
    {
        if (email == '*') return 'Alle';
        return this.user_initials[email] || '?';
    }

    getUserName(email)
    {
        return this.user_names[email] || '?';
    }

    clientUpdated(user)
    {
        let user_options = [];
        let user_initials = {};
        let user_names = {};
        
        if (user.client)
        {
            let members = user.client.members || [];
            for (let i = 0; i < members.length; i++)
            {
                let name = members[i].name || members[i].mail;
                user_options.push({ key: members[i].mail, value: name, admin: !!members[i].admin });
                user_initials[members[i].mail] = members[i].initials;
                user_names[members[i].mail] = name;
            }
        }

        this.user_options = user_options;
        this.user_initials = user_initials;
        this.user_names = user_names;
        this.user_mail = user.mail;
    }
}
const TcrLogin = new TcrLoginClass();
export { TcrLogin };